module.exports = __webpack_public_path__ + "static/kzv-logo-3f6c86602f5cec481a35826beafc9da6.png";